import { useHttp } from '../http'

export const useUserMainGoalHttp = (userId: number) => {

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`users/${userId}/main-goals`, payload)
    }

    const find = <T>(id: number, payload?: any): Promise<T> => {
        return useHttp().get(`users/${userId}/main-goals/${id}`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`users/${userId}/main-goals/${id}`)
    }

    return {
        get,
        find,
        del,
    }
}